import React, { createContext, type FC } from "react";
import clsx from "clsx";

export const Skeleton: FC<{
  width?: number;
  height?: number;
  borderRadius?: number;
  className?: string;
}> = ({ width = 48, height = 24, borderRadius = 32, className }) => {
  return (
    <div
      className={clsx("bg-orange-5 rounded-3xl animate-pulse", className)}
      style={{ width, height, borderRadius }}
    />
  );
};

interface PartyInvitationCardContextProps {
  name?: string;
  avatarImage?: string;
  ownerName?: string;
  members?: number;
  ownerAvatarImage?: string;
  ownerNFTImage?: string;
  walletAddress?: string;
  isRendering: boolean;
}

export const PartyInvitationCardContext =
  createContext<PartyInvitationCardContextProps>({
    name: "",
    avatarImage: "",
    ownerName: "",
    members: 0,
    ownerAvatarImage: "",
    ownerNFTImage: "",
    walletAddress: "",
    isRendering: true,
  });
